import { Alert, Button, Space, Statistic, Typography } from "antd";
import { CheckCircleOutlined } from "../icons";

const { Text } = Typography;

export interface ScriptPreviewSummaryProps {
  messageCount: number;
  roleCount: number;
  memberCount: number;
  membersLoading?: boolean;
  onConfirm: () => void;
  confirming?: boolean;
  disabled?: boolean;
}

export function ScriptPreviewSummary({
  messageCount,
  roleCount,
  memberCount,
  membersLoading,
  onConfirm,
  confirming,
  disabled,
}: ScriptPreviewSummaryProps) {
  return (
    <div style={{ marginBottom: 16 }}>
      <Space size="large" wrap style={{ marginBottom: 16 }}>
        <Statistic title="消息总数" value={messageCount} suffix="条" />
        <Statistic title="气氛员角色" value={roleCount} suffix="个" />
        <Statistic
          title="可匹配气氛员账号"
          value={membersLoading ? "—" : memberCount}
          suffix={membersLoading ? undefined : "个"}
        />
      </Space>

      <Alert
        type="warning"
        showIcon
        message="请确认剧本细节无误"
        description="请核对下方表格中的角色与需发内容，确认无误后将自动完成图片理解、画像分析与气氛员匹配。"
        style={{ marginBottom: 16 }}
      />

      <Button
        type="primary"
        size="large"
        icon={<CheckCircleOutlined />}
        loading={confirming}
        disabled={disabled || roleCount === 0}
        onClick={onConfirm}
      >
        确认无误，开始处理
      </Button>
      {roleCount === 0 ? (
        <div style={{ marginTop: 8 }}>
          <Text type="secondary">当前没有需要匹配的气氛员角色</Text>
        </div>
      ) : null}
    </div>
  );
}
